'use client';
import { useEffect } from 'react';

// Enregistre le service worker app-shell (cf. public/sw.js) — sans lui, "Ajouter à l'écran
// d'accueil" ne fonctionne pas réellement sur Chrome/Android (critère d'installabilité), et il
// n'y a aucun fallback hors-ligne. Composant client isolé car layout.tsx (racine) est un
// composant serveur.
export default function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed', err);
    });
  }, []);

  return null;
}
